export type VerdictKey = "实锤" | "存疑" | "待定" | "辟谣";

export interface VerdictStyle {
  label: VerdictKey;
  badge: string;
  dot: string;
  bar: string;
  text: string;
  soft: string;
  note: string;
}

const styles: Record<VerdictKey, VerdictStyle> = {
  实锤: {
    label: "实锤",
    badge: "bg-primary-500 text-background-50 border-primary-500",
    dot: "bg-primary-500",
    bar: "bg-primary-500",
    text: "text-primary-700",
    soft: "bg-primary-50 border-primary-200 text-primary-700",
    note: "已有可独立核验的硬证据且多方印证",
  },
  存疑: {
    label: "存疑",
    badge: "bg-accent-500 text-secondary-950 border-accent-500",
    dot: "bg-accent-500",
    bar: "bg-accent-500",
    text: "text-accent-700",
    soft: "bg-accent-50 border-accent-200 text-accent-800",
    note: "证据倾向成立，但关键环节仍依赖单一来源",
  },
  待定: {
    label: "待定",
    badge: "bg-background-200 text-foreground-800 border-background-300",
    dot: "bg-foreground-400",
    bar: "bg-foreground-400",
    text: "text-foreground-700",
    soft: "bg-background-100 border-background-300 text-foreground-700",
    note: "线索零散、来源等级偏低，需继续观察",
  },
  辟谣: {
    label: "辟谣",
    badge: "bg-secondary-500 text-background-50 border-secondary-500",
    dot: "bg-secondary-500",
    bar: "bg-secondary-500",
    text: "text-secondary-700",
    soft: "bg-secondary-50 border-secondary-200 text-secondary-800",
    note: "已出现官方回应或硬反证，传闻不成立",
  },
};

export function getVerdictStyle(verdict: string): VerdictStyle {
  return styles[(verdict as VerdictKey) in styles ? (verdict as VerdictKey) : "待定"];
}

export function formatHeat(heat: number): string {
  if (heat >= 10000) return `${(heat / 10000).toFixed(1)} 万`;
  return `${heat}`;
}